module.exports = __webpack_public_path__ + "img/64.5e3a8c48.jpeg";